// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"24a4e79e","105":"13538e93","453":"b16b9671"}[chunkId] + ".chunk.js";
};